<template>
  <!-- {{ item }} -->
  <div
    class="px-2.5 py-1.5 my-2 mr-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-purple-300 bg-white "
>
    <div class="relative mobile:flex-col tablet:flex tablet:flex-row justify-between gap-2">
      <div class="w-10">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>ID:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ item.id }}
        </p>
      </div>
      <div class="w-24 largeDesktop:w-32 relative group">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Name:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.first_name) ? '-' : item.first_name }} {{ $helper.isEmpty(item.last_name) ? '-' :
            item.last_name }}
        </p>
      </div>

      <div class="w-24 largeDesktop:w-32 relative group">
        <span class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block">
          Email:
        </span>

        <p class="m-0 font-roboto text-base font-400 ">
          {{ $helper.isEmpty(item.email) ? '-' : item.email }}
        </p>
      </div>
      <div class="w-28">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Phone:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.phone) ? '-' : item.phone }}
        </p>
      </div>
      <div class="w-20">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Frequency:</span>
        <p class="m-0 font-roboto text-base font-400">
          {{ $helper.isEmpty(item.distribution_frequency_text) ? '-' : item.distribution_frequency_text }}
        </p>
      </div>

      <div class="w-20">
        <span
          class="text-[#EA8A8A] font-roboto text-base tablet:min-h-[50px] desktop:!min-h-[auto] inline-block"
>Status:</span>
        <p class="m-0 font-roboto text-base font-400"> 
          <span v-if="item.active == '1'" class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#65B741] text-[#fff]">Active</span>
          <span v-else class="text-[12px] px-[10px] py-[3px] rounded-[3px] bg-[#EA8A8A] text-[#fff]">Inactive</span>
        </p>
      </div>



      <div class="w-20 flex items-center justify-center ">
<div ref="dropdownWrapper">
          <div class="relative">
            <button class="focus:outline-none" @click="toggleDropdown">
              <img src="../../../assets/images/vertical-dot-icon.png" alt="Up Down Arrow" class="w-[25px] h-[25px]">
            </button>
            <ul v-if="isOpen" class="absolute right-0 z-10 mt-1 w-[100px] bg-white rounded shadow-lg text-gray-700 text-sm p-0 overflow-hidden">
              <li
v-for="option in getActions()" :key="option" class="px-2 py-1 hover:bg-indigo-100 cursor-pointer text-left"
                @click="select(option)"
>
                {{ option }}
              </li>
            </ul>
          </div>
        </div>
      </div>
</div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: ["item"],
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {

    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {

    getActions() {
      let res = ["Edit"]
      if (this.item.active == '1') {
        res = ["Edit", "Inactive"]
      } else {
        res = ["Edit", "Active"]
      }
      return res
    },


    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(value) {
      // this.selected = value;
      this.isOpen = false;
      this.$emit('update', this.item, value); // emit change if needed
    },
    handleClickOutside(event) {
      if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },
  }
};
</script>